<div class="flex justify-content-between" style="height:34px">
  <div><ng-content select="[left]"></ng-content></div>
  <div>
    <ng-content select="[right]"></ng-content>
  </div>
</div>
